import React from 'react';
import queryString from 'query-string';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import './BeginChallengeChecklist.scss';
import ChecklistForm from './components/ChecklistForm';
import BeginChallengeDashboardHeader from '../beginChallengeTeamDashboard/beginChallengeDashBoardHeader/BeginChallengeDashboardHeader';
import { getDataFromSession, getParamsString } from '../../../utill.func';
import { commonConstant } from '../../../common';

const ASSESSMENT_ID = process.env.REACT_APP_BEGIN_CHALLENGE_ASSESSMENT_ID;

const BeginChallengeChecklist = () => {
  const history = useHistory();
  const location = useLocation();
  const params = queryString.parse(location.search);
  const challengeHeaderDate = params['challengeHeaderDate'];
  const challengeId = params['challengeId'];
  const eventId = params['eventId'];
  const { partyId } = getDataFromSession('customer');

  const beginSelectedChallenge = useSelector(
    (state) => state.challengeListObj?.beginSelectedChallenge?.challengeDetails,
  );

  const challengeData = getDataFromSession('beginChallengeData');

  const backgroundImage = challengeData?.teamDashboardImg
    ? challengeData?.teamDashboardImg
    : beginSelectedChallenge?.teamDashboardImage;

  const onBackClick = () => {
    history.goBack();
  }

  const handleFinish = (result) => {
    console.log('[BeginChallengeChecklist] onFinish result:', result);
    const dashboardParams = { challengeId, eventId, partyId, isRegistered: true };
    history.replace(
      `${commonConstant.pathBeginChallengeTeamDashBoard}?${getParamsString(dashboardParams)}`,
    );
  };

  return (
    <div
      className="begin-challenge-checklist-container"
      style={backgroundImage ? { '--dynamic-bg-image': `url(${backgroundImage})` } : undefined}
    >
      <BeginChallengeDashboardHeader
        date={challengeHeaderDate}
        showBackButton={true}
        onBackClick={onBackClick}
      />
      <ChecklistForm
        assessmentId={ASSESSMENT_ID}
        onFinish={handleFinish}
      />
    </div>
  );
};

export default BeginChallengeChecklist;
